module.exports = __webpack_public_path__ + "Server-Unknown.TentacleActive.4adcf4e0ce2b948017e261c88b2dd60e.hashedasset.svg";